import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.GroupOfValuesPopup.AddCommentPopupContent', {
    popupTitle: 'Add a comment about the changes made',
    description1: `You're updating the current group of values.`,
    description2: 'To inform others about the changes, you can leave a comment here (optional).',
    buttonText: 'Confirm',
    addCommentPlaceholder: 'Add a comment',
});
